import { Company } from "../../types/Company";
import { AccelPlaidAccount } from "../../types/AccelPlaidAccount";
import { get } from "./authenticatedrequestUtil";
import { CompanyPlaidAccounts } from "../../types/CompanyPlaidAccounts";

export const getAccounts = get<{
  plaidAccounts: CompanyPlaidAccounts[];
  totalBalance: number;
}>(({ companyId }) => `/${companyId}/accounts/Total`);
